import dialog from '@/components/Dialog'
import pagination from '@/components/Pagination'
import printTable from '@/components/printTable'
import printTable2 from '@/components/printTable/print2'
import photoDerive from '@/components/photoDerive'
import PageChange from '@/components/pageChange'
import ELCascader from '@/components/element-ui/ELCascader'
import ElTableColumn from '@/components/element-ui/ElTableColumn'

export default {
	install (Vue) {
		Vue.component('setDialog', dialog)
		Vue.component('pagination', pagination)
		Vue.component('printTable', printTable)
		Vue.component('printTable2', printTable2)
		Vue.component('photoDerive', photoDerive)
		Vue.component('pageChange', PageChange)
		Vue.component(ELCascader.name, ELCascader)
		Vue.component(ElTableColumn.name, ElTableColumn)
	}
}
